<template>
  <v-app>
    <component :is="layout"> </component>
  </v-app>
</template>

<script>
import Login from "@/views/Login.vue";
import Basepage from "@/views/Basepage.vue";
import { mapActions } from "vuex";

export default {
  name: "App",
  computed: {
    layout() {
      return this.$store.getters.token
        ? this.$route.meta.layout || "basepage"
        : "login";
    },
  },
  components: {
    Login,
    Basepage,
  },
  methods: {
    ...mapActions(["checkToken"]),
  },
  async created() {
    await this.checkToken({layout: this.layout});
  },
};
</script>
